import React, { useEffect } from "react";
import Notification from "../../Notification";
import PropTypes from "prop-types";
import { X } from "react-feather";
import { animated, config, useTransition } from "@react-spring/web";

const SECOND = 1000;

const NotificationPopup = ({
    open = false,
    type = "success",
    children,
    onClose,
    showX = true,
    closeInSeconds = 4.5,
}) => {
    useEffect(() => {
        if (closeInSeconds > 0) {
            const duration = closeInSeconds * SECOND;
            const timer = setTimeout(() => closePopup(), duration);
            return () => clearTimeout(timer);
        }
    }, [open, closeInSeconds]);

    const closePopup = () => open && onClose();
    const transition = useTransition(open, {
        from: { y: 500, opacity: 0 },
        enter: { y: 0, opacity: 1 },
        leave: { y: 500 },
        config: { ...config.molasses, duration: 400 },
    });

    return transition(
        (styles, item) =>
            item && (
                <animated.div style={styles} className="notification-popup">
                    <div className="popup-container">
                        {showX && (
                            <X
                                size={24}
                                className="close-popup"
                                onClick={closePopup}
                            />
                        )}
                        <Notification type={type}>{children}</Notification>
                    </div>
                </animated.div>
            )
    );
};

NotificationPopup.propTypes = {
    open: PropTypes.bool,
    type: PropTypes.oneOf(["danger", "success", "warning"]),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    onClose: PropTypes.func,
    showX: PropTypes.bool,
};

export default NotificationPopup;
